module.exports = __webpack_public_path__ + "img/perfect-vulnerability.e02f376a.png";